module.exports = __webpack_public_path__ + "Roboto-300.1edaa6e50c2302bf0221.svg";


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src634836211/src/src/assets/fonts/roboto/fonts/Roboto-300/Roboto-300.svg
// module id = ../../../../../src/assets/fonts/roboto/fonts/Roboto-300/Roboto-300.svg
// module chunks = main styles